import { useContext } from "react";
import styled from "styled-components";
import { AppContext } from "../../context";

const StyledLogo = styled.img`
  width: 100%;
  height: auto;
`;

const Logo = () => {
  const { appLogo, appName } = useContext(AppContext);

  return <StyledLogo src={appLogo} alt={appName} />;
};

export default Logo;
